import { Registry } from "scantling-common";
import type { ComponentType } from "react";

export interface RouteDefinition {
  type: string;
  /** Route path pattern, e.g. "/o/:orgSlug/overview" */
  path: string;
  /** Display label for navigation */
  label: string;
  /** Page component */
  component: ComponentType;
}

export const routeRegistry = new Registry<RouteDefinition>();

export function getRoutes(): RouteDefinition[] {
  return routeRegistry.getAll();
}
